(function () {
  if (window.customAddToCartLoaded) return;
  window.customAddToCartLoaded = true;

  // Move all variant popups to <body> so they escape card overflow:hidden
  function relocatePopups() {
    var popups = document.querySelectorAll('.custom-variant-popup');
    popups.forEach(function (popup) {
      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocatePopups);
  } else {
    relocatePopups();
  }

  // Re-run when new content loads (for AJAX-injected sections such as
  // product recommendations). Debounced so the cart-drawer re-render
  // this script triggers doesn't cause a mutation storm.
  var relocateScheduled = false;
  var observer = new MutationObserver(function () {
    if (relocateScheduled) return;
    relocateScheduled = true;
    requestAnimationFrame(function () {
      relocateScheduled = false;
      relocatePopups();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Open / close variant popup
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.custom-variant-trigger');
    if (trigger) {
      e.preventDefault();
      var targetId = trigger.getAttribute('data-target');
      var popup = document.getElementById(targetId);
      if (popup) {
        popup.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    var closeBtn = e.target.closest('[data-close]');
    if (closeBtn) {
      var openPopup = closeBtn.closest('.custom-variant-popup');
      if (openPopup) {
        openPopup.hidden = true;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }
  });

  // Close popup with ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openPopups = document.querySelectorAll('.custom-variant-popup:not([hidden])');
      if (openPopups.length > 0) {
        openPopups.forEach(function (p) {
          p.hidden = true;
        });
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }
  });

  // Add to cart handler
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.custom-add-to-cart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId;
    var popupId = btn.getAttribute('data-popup-id');

    if (popupId) {
      var sourcePopup = document.getElementById(popupId);
      if (sourcePopup) {
        var checked = sourcePopup.querySelector('input[type="radio"]:checked');
        if (checked) variantId = checked.value;
      }
    } else {
      variantId = btn.getAttribute('data-variant-id');
    }

    if (!variantId) {
      alert('Please select an option');
      return;
    }

    var btnText = btn.querySelector('.btn-text');
    var btnLoading = btn.querySelector('.btn-loading');

    if (btnText) btnText.style.display = 'none';
    if (btnLoading) btnLoading.style.display = 'inline';
    btn.disabled = true;

    try {
      var cartDrawer = document.querySelector('cart-drawer');
      var sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : undefined;

      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });

      if (!addResponse.ok) {
        var errorData = await addResponse.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      var responseData = await addResponse.json();

      if (cartDrawer && responseData.sections && responseData.sections['cart-drawer']) {
        var drawerDoc = new DOMParser().parseFromString(responseData.sections['cart-drawer'], 'text/html');
        var newDrawer = drawerDoc.querySelector('cart-drawer');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.classList.remove('is-empty');
        }
      }

      if (responseData.sections && responseData.sections['cart-icon-bubble']) {
        var cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          var bubbleDoc = new DOMParser().parseFromString(responseData.sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('.shopify-section');
          if (newBubble) cartIconBubble.innerHTML = newBubble.innerHTML;
        }
      }

      // Close popup if it was open
      if (popupId) {
        var donePopup = document.getElementById(popupId);
        if (donePopup) {
          donePopup.hidden = true;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
      }

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(btn);
      } else {
        var cartNotification = document.querySelector('cart-notification');
        if (cartNotification && typeof cartNotification.open === 'function') {
          cartNotification.open();
        }
      }
    } catch (err) {
      console.error('Add to cart error:', err);
      alert('Could not add to cart: ' + err.message);
    } finally {
      if (btnText) btnText.style.display = 'inline';
      if (btnLoading) btnLoading.style.display = 'none';
      btn.disabled = false;
    }
  });
})();
